import type { PageCard } from '@/play/pageTypes'
import { RightWayCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'right-way',
  number: 23,
  title: 'Right way',
  question: 'Is a subtle change in the material enough to show a child they traced a stroke the right way?',
  status: 'open',
  accent: '#f3ecdc',
  CardArt: RightWayCardArt,
}
